import React from 'react';
import { Flex, Image, Text } from '@chakra-ui/react';
import { Link } from 'react-router-dom';
import { ContentContainer } from '../../components/ContentContainer/contentContainer';
import Vendor from '../../vendor.config';

export const PageNotFound = () => {
	return (
		<ContentContainer>
			<Flex
				p="0 20px"
				flexDirection="column"
				height="100vh"
				justifyContent="center"
				alignItems="center"
			>
				<Image
					src={Vendor.gui.asset.logo}
					alt="GameXplorer"
					w={{ base: '270px', md: '350px' }}
				/>
				<Flex
					justifyContent="center"
					textAlign="center"
					fontSize={{ base: '25px', sm: '35px', md: '42px' }}
					color="action"
				>
					[404] - PAGE NOT FOUND
				</Flex>
				<Flex fontSize="20px">
					Click
					<Text
						m="0 5px"
						color="action"
						_hover={{ color: 'action' }}
					>
						<Link to="/">here</Link>
					</Text>
					to return to Homepage{' '}
				</Flex>
			</Flex>
		</ContentContainer>
	);
};
